import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n'], ['\n  box-sizing: border-box;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  ', ';\n'], ['\n  ', ';\n']);

import styled, { css } from 'styled-components';
import { TableBodyCell } from '../TableCell';

var rankingStyles = css(_templateObject);

export var RankableTableBodyCell = styled(TableBodyCell)(_templateObject2, function (_ref) {
  var isRanking = _ref.isRanking;
  return isRanking && rankingStyles;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/dynamic-table/dist/esm/styled/rankable/TableCell.js
// module id = 898
// module chunks = 0